import { Link } from "react-router-dom";
import { useSiteConfig } from "@/context/SiteConfigContext";

export default function SMSPolicy() {
  const { formatted_phone } = useSiteConfig();
  
  return (
    <div data-testid="sms-policy-page" className="pt-20">
      {/* Hero */}
      <section className="py-16 bg-[#1a1a1a] text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 
            className="text-4xl md:text-5xl font-bold uppercase tracking-wide"
            style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
          >
            SMS/Text Message Policy
          </h1>
          <p className="text-gray-400 mt-2">Last updated: February 2026</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-lg">
          <h2>1. SMS Communication Consent</h2>
          <p>
            By providing your mobile phone number and opting in to SMS communications from Overhaul Ops LLC, you consent to receive text messages from us regarding:
          </p>
          <ul>
            <li>Service appointment confirmations and reminders</li>
            <li>Quote follow-ups</li>
            <li>Service status updates</li>
            <li>Review requests</li>
            <li>Promotional offers (if opted in)</li>
          </ul>

          <h2>2. Message Frequency</h2>
          <p>
            Message frequency varies. You may receive:
          </p>
          <ul>
            <li>1-3 messages per service inquiry</li>
            <li>Appointment reminders (1-2 per scheduled service)</li>
            <li>Promotional messages (up to 4 per month if opted in)</li>
          </ul>

          <h2>3. Message and Data Rates</h2>
          <p>
            <strong>Message and data rates may apply.</strong> Your carrier's standard messaging and data rates will apply to any messages you send or receive. Check with your mobile carrier for details about your plan.
          </p>

          <h2>4. How to Opt-Out</h2>
          <p>
            You can opt out of receiving text messages at any time by:
          </p>
          <ul>
            <li>Replying <strong>STOP</strong> to any text message from us</li>
            <li>Calling us at {formatted_phone}</li>
            <li>Emailing overhaulops.llc@gmail.com with "Unsubscribe SMS" in the subject</li>
          </ul>
          <p>
            After opting out, you will receive one final confirmation message. You will no longer receive SMS messages from us unless you opt back in.
          </p>

          <h2>5. How to Get Help</h2>
          <p>
            For help with our SMS program, reply <strong>HELP</strong> to any message or contact us:
          </p>
          <ul>
            <li><strong>Phone:</strong> {formatted_phone}</li>
            <li><strong>Email:</strong> overhaulops.llc@gmail.com</li>
          </ul>

          <h2>6. Supported Carriers</h2>
          <p>
            Our SMS services are available on most major U.S. carriers including AT&T, Verizon, T-Mobile, Sprint, and others. Carriers are not liable for delayed or undelivered messages.
          </p>

          <h2>7. Privacy</h2>
          <p>
            Your phone number and opt-in consent will not be sold or shared with third parties for marketing purposes. See our <Link to="/privacy-policy" className="text-[#b51a00] hover:underline">Privacy Policy</Link> for more details on how we handle your information.
          </p>

          <h2>8. Program Description</h2>
          <p>
            Overhaul Ops LLC uses SMS messaging to provide better customer service for our junk removal, hauling, clean out, and light demolition services in the Dallas-Fort Worth metroplex.
          </p>

          <h2>9. Terms</h2>
          <p>
            By opting in to our SMS program, you agree to these terms and our <Link to="/privacy-policy" className="text-[#b51a00] hover:underline">Privacy Policy</Link>. We reserve the right to modify these terms at any time.
          </p>

          <h2>10. Contact Information</h2>
          <div className="bg-gray-100 p-6 rounded-sm">
            <p><strong>Overhaul Ops LLC</strong></p>
            <p>Phone: {formatted_phone}</p>
            <p>Email: overhaulops.llc@gmail.com</p>
            <p>Service Area: Denton, Tarrant, Parker, Wise Counties, TX</p>
          </div>

          <div className="mt-8 p-4 border-l-4 border-[#b51a00]">
            <p className="text-sm text-gray-700">
              <strong>Important:</strong> By checking the SMS consent box on our contact form, you agree to receive text messages from Overhaul Ops LLC at the phone number provided. Consent is not required to purchase services.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
